<div class="vb-search" role="search">
    <div class="vb-header-search-field">
        <vb-icon name="search" [size]="18" [strokeWidth]="1.6"></vb-icon>
        <input
            #searchInput
            class="vb-header-search-input"
            (input)="handleSearchSubmit($event)"
            type="text"
            [placeholder]="placeholder"
            [attr.aria-label]="ariaLabel"
            name="searchText"
            autocomplete="off" />
        <span
            *ngIf="isLoading"
            class="vb-search__spinner"
            role="status"
            aria-label="Loading search results">
            <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <circle
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    stroke-width="3"
                    stroke-linecap="round"
                    opacity="0.25" />
                <path
                    d="M12 2a10 10 0 0 1 10 10"
                    stroke="currentColor"
                    stroke-width="3"
                    stroke-linecap="round" />
            </svg>
        </span>
        <button
            *ngIf="searchText"
            type="button"
            class="vb-header-search-clear"
            aria-label="Clear search"
            (click)="clearSearch(searchInput)">
            <vb-icon name="close" [size]="15" [strokeWidth]="2"></vb-icon>
        </button>
    </div>

    <div
        *ngIf="noResults && isDropdownOpen"
        class="vb-dropdown-panel vb-search__panel vb-search__empty">
        No results found
    </div>

    <ol
        *ngIf="searchList.length > 0 && isDropdownOpen"
        class="vb-dropdown-panel vb-search__panel vb-search__results">
        <li
            *ngIf="auctionsList.length > 0"
            class="vb-dropdown-eyebrow vb-search__section">
            Auctions
        </li>
        <li class="vb-search__item" *ngFor="let auction of auctionsList">
            <a
                (click)="navigate(auction.id)"
                (keydown.enter)="navigate(auction.id)"
                tabindex="0"
                role="button"
                [attr.aria-label]="'View auction: ' + auction.name">
                <span
                    class="vb-search__category-dot"
                    [ngClass]="getCategoryClass(auction.auctionType)"
                    aria-hidden="true"></span>
                <span class="vb-search__meta">
                    <span class="vb-search__title">{{ auction.name }}</span>
                    <span
                        class="vb-search__desc"
                        [innerHTML]="
                            sanitizeDescription(auction.description)
                        "></span>
                </span>
            </a>
        </li>

        <li
            *ngIf="lotList.length > 0"
            class="vb-dropdown-eyebrow vb-search__section">
            Lots
        </li>
        <li class="vb-search__item" *ngFor="let lot of lotList">
            <a
                (click)="navigate(lot.auctionid, lot.id)"
                (keydown.enter)="navigate(lot.auctionid, lot.id)"
                tabindex="0"
                role="button"
                [attr.aria-label]="'View lot: ' + lot.title">
                <img
                    *ngIf="lot.images !== undefined && lot.images.length > 0"
                    class="vb-search__thumb"
                    [src]="lot.images[0].url"
                    alt="" />
                <img
                    *ngIf="lot.images === undefined || lot.images.length < 1"
                    class="vb-search__thumb"
                    src="/assets/img/brand/no-image-lot.svg"
                    alt="" />
                <span class="vb-search__meta">
                    <span class="vb-search__title">{{ lot.title }}</span>
                    <span
                        class="vb-search__desc"
                        [innerHTML]="
                            sanitizeDescription(lot.description)
                        "></span>
                </span>
                <span class="vb-search__price vb-num"
                    >${{ lot.currentbid }}</span
                >
            </a>
        </li>
    </ol>
</div>
